export const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"] as const;

export const TIME_SLOTS = Array.from({ length: 11 }, (_, i) => `${i + 8}:00`);

export const CAMPUSES = {
  'Busch': {
    gradient: 'from-blue-500 to-blue-700',
    label: 'Busch Campus',
    color: 'blue'
  },
  'Livingston': {
    gradient: 'from-orange-500 to-orange-700',
    label: 'Livingston Campus',
    color: 'orange'
  },
  'College Avenue': {
    gradient: 'from-yellow-500 to-yellow-700',
    label: 'College Avenue Campus',
    color: 'yellow'
  },
  'C/D': {
    gradient: 'from-green-500 to-emerald-700',
    label: 'Cook/Douglass Campus',
    color: 'green'
  }
} as const;

// Colors for unique class gradients - Scarlet Sync theme
export const CLASS_COLORS = [
  'red',
  'pink',
  'rose',
  'orange',
  'amber',
  'yellow',
  'lime',
  'emerald',
  'teal',
  'cyan'
] as const;

export const TRAVEL_TIMES: { [key: string]: { [key: string]: number } } = {
  'Busch': {
    'Livingston': 15,
    'College Avenue': 20,
    'C/D': 25,
    'New Brunswick': 20,
  },
  'Livingston': {
    'Busch': 15,
    'College Avenue': 25,
    'C/D': 30,
    'New Brunswick': 25,
  },
  'College Avenue': {
    'Busch': 20,
    'Livingston': 25,
    'C/D': 15,
    'New Brunswick': 5,
  },
  'C/D': {
    'Busch': 25,
    'Livingston': 30,
    'College Avenue': 15,
    'New Brunswick': 15,
  },
  'New Brunswick': {
    'Busch': 20,
    'Livingston': 25,
    'College Avenue': 5,
    'C/D': 15,
  }
};

// Performance and display limits
export const SCHEDULE_DISPLAY_LIMITS = {
  MAX_SCHEDULES_TO_DISPLAY: 100, // Only display top 100 in UI, but still compute all
  MAX_COURSES_FOR_GENERATION: 15, // Maximum number of courses before limiting schedule generation
  SCHEDULE_GENERATION_TIMEOUT: 10000, // Timeout for schedule generation in milliseconds
  MAX_DISTINCT_COURSE_LIST_COURSES: 10, // Maximum distinct courses explored per course-list block
} as const;

export const SCHOOL_DEGREE_IDS = [2721, 5962, 7602, 7603, 2841, 2841, 5722, 5964, 5661, 2742, 7986, 29, 13, 18, 53, 5966, 5963, 5965];
